define([
    "dojo/_base/array",
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/util",
    "csi/locale",
    "csi/action/Controller",
    "csi/comm/PostRequest",
    "csi/widget/MessageDialog",
    "csi/widget/IFrameDialog"
], function(array,declare,lang,util,locale,Controller,PostRequest,MessageDialog,IFrameDialog) {

    return declare([Controller], {

        /** @property {boolean} bDownloadResponse - Set to true if the response shall be downloaded */
        bDownloadResponse: false,

        /** @property {boolean} bRenderInFrameDialog - Set to true if the response shall be embedded in an iframe dialog */
        bRenderInFrameDialog: false,

        /** @property {boolean} bConfirmDownload - Set to true if file download needs to be confirmed */
        bConfirmDownload: false,

        /** @property {string} connector - The name (Connector field in C8) of the MicroServiceConnector used */
        connector: null,

        /** @property {string} mimeType - The mimeType of the expected response */
        mimeType: null,

        /** @property {string} fileName - The filename to be used should the response be downloaded in a file */
        fileName: null,

        /** @property {PostRequest} apiRequest - The PostRequest which fetches data from the external API */
        apiRequest: null,

        /** @property {string} dialogTitle - The dialog title */
        dialogTitle: null,

        /** @property {string} dialogStyle - The dialog style CSS value which accommodates the iframe */
        dialogStyle: null,

        /** @property {string} frameStyle -  The iframe style CSS value */
        frameStyle: null,

        /** @property {element} anchor -  The anchor element used for downloading the response */
        anchor: null,

        /** @property {string} url -  The anchor element's url */
        url: null,

        /**
         * Returns the downloadable file name based on mimeType provided
         * @return {string}
         */
        getDownloadFileName: function() {

            this.fileName = this.fileName ? this.fileName : util.uuid();
            let extension;

            switch (this.mimeType) {
                case 'application/pdf': extension = '.pdf'; break;
                case 'application/xml':	extension = '.xml'; break;
                case 'text/plain': extension = '.txt'; break;
            }

            return this.fileName + extension;
        },

        getFormData: function() {
            const fd = this.inherited(arguments);
            fd.m_bRequireOne = true;
            return fd;
        },

        getConfirmButton: function() {
            return MessageDialog.BUTTON_PROCEED;
        },

        /**
         * Prepares the response for download
         * @param {XHR} response
         */
        prepareDownload: function(/*Response*/response){

            const blob = new Blob([response.data], { type: this.mimeType });

            // Create an object URL for the blob object
            this.url = window.URL.createObjectURL(blob);

            // Create a new anchor element
            this.anchor = document.createElement('a');
            this.anchor.id = util.uuid();

            // Set the href and download attributes for the anchor element
            this.anchor.href = this.url;
            this.anchor.download = this.getDownloadFileName();
        },

        /**
         * Invalidates the download url and removes the anchor element from DOM
         */
        cleanup: function() {
            URL.revokeObjectURL(this.url);
            dojo.destroy(this.anchor.id);
        },

        /**
         * Presents a confirmation dialog to the user for downloading the response into an appropriate file
         */
        confirmDownload: async function() {

            return new Promise((resolve, reject) => {
                if (!this.bDownloadResponse){
                    resolve();
                } else {
                    if(this.bConfirmDownload){
                        this.confirmAction({
                            message: locale.resource("GeneratedFileDownload_Prompt"),
                            materialIcon: MessageDialog.ICON_INFO,
                            onResponse: key => {
                                if (key === this.getConfirmButton()) {
                                    this.anchor.click();
                                }
                                this.cleanup();
                                resolve();
                            }
                        });
                    } else{
                        this.anchor.click();
                        this.cleanup();
                        resolve();
                    }
                }
            });
        },

        /**
         * Displays the external API's response into a normal dialog or an IFrame dialog
         * @param {XHR} response
         */
        displayResponse: function(/*Response*/response){

            let dialog;
            if(this.bRenderInFrameDialog){
                dialog = new IFrameDialog({
                    buttons: [IFrameDialog.BUTTON_OK, IFrameDialog.BUTTON_REFRESH],
                    mimeType: this.mimeType,
                    iframeSrc: response.data,
                    iframeRequest: this.apiRequest,
                    style: this.dialogStyle,
                    frameStyle: this.frameStyle,
                    title: this.dialogTitle
                });
            } else {
                dialog = new MessageDialog({
                    buttons: [MessageDialog.BUTTON_OK],
                    message: response.data,
                    style: this.dialogStyle,
                    title: this.dialogTitle
                });
            }
            dialog.show();
        },

        process: function() {
            const fd = this.m_formData;

            this.setProgress();

            const prepareDownload = lang.hitch(this, this.prepareDownload);
            const confirm = lang.hitch(this, this.confirmDownload);
            const display = lang.hitch(this, this.displayResponse);
            const publish = lang.hitch(this, this._onPublishResponse);
            const method = this.bDownloadResponse ? prepareDownload : display;

            this.apiRequest = new PostRequest("SiteAdmin", "SubmitUrlCollectionAndHandleResponse")
                .addParameter("AddURLs", fd.getSelectedValue())
                .addParameter("Connector", this.connector)
                .addParameter("MimeType", this.mimeType);

            this.apiRequest.post().then(response => method(response)).then(confirm).then(publish);
        }
    });
});
